import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './CloseFullscreenMapButton.css';

interface ICloseFullscreenMapButtonProps {
  onClick(): void;
}

export function CloseFullscreenMapButton({ onClick }: ICloseFullscreenMapButtonProps) {
  return (
    <div className={styles['close']} onClick={onClick}>
      <IconActionClose16 color={'icon-inverted-default'} />
    </div>
  );
}
